(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fcc-information-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fcc-faq]').forEach((source) => {
    const children = Array.from(source.children);
    const fragment = document.createDocumentFragment();
    let index = 0;

    while (index < children.length) {
      const child = children[index];
      if (child.tagName !== 'H3') {
        fragment.appendChild(child);
        index += 1;
        continue;
      }

      const details = document.createElement('details');
      const summary = document.createElement('summary');
      const label = document.createElement('span');
      const icon = document.createElement('span');
      const answer = document.createElement('div');
      label.textContent = child.textContent;
      icon.textContent = '+';
      icon.setAttribute('aria-hidden', 'true');
      summary.append(label, icon);
      details.append(summary, answer);
      index += 1;

      while (index < children.length && children[index].tagName !== 'H3' && children[index].tagName !== 'H2') {
        answer.appendChild(children[index]);
        index += 1;
      }
      fragment.appendChild(details);
    }

    source.replaceChildren(fragment);
    source.classList.add('fcc-info__faq');
    const firstRow = source.querySelector('details');
    if (firstRow) firstRow.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
